<div [class.no-margin-y]="noMarginY">
    <div *ngIf="loading" [class.normal-loader]="!opaque" [class.opaque-centered-loader]="opaque">
        <loader [loaderType]="loaderType" [noMarginY]="noMarginY"></loader>
    </div>
    <div *ngIf="!loading || (loading && opaque)" [class.opaque-content]="loading && opaque">
        <ng-content></ng-content>
    </div>
</div>
